import React, { Component } from 'react';
import GameView from './GameView.js';
import Shared from './Shared.js';
import Mii from './Mii.js';
import { Link } from 'react-router-dom';


import singles from './content/singles_tierlist.png';
import doubles from './content/doubles_tierlist.png';

const appContent = require('./content/app.json');

// const mii_data = require('./data/miis.json');
// const nameImgs = require('./data/name_imgs.json');


class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {loading:true};
    }
    
    componentDidMount() {
        let shared = Shared.get();
        // shared.setMiisB64(mii_data);
        // shared.setNamesB64(nameImgs);

        if (shared.miis === null) {
            let that = this;
            
            fetch("https://skydereign.github.io/forglory-data/miis.json")
                .then(function(response) {
                    return response.json();
                }).then(function(data) {
                    let shared = Shared.get();
                    shared.setMiisB64(data);
                    that.setState({loading:false});
                });
        } else {
            this.setState({loading:false});
        }
    }
    render() {
        let shared = Shared.get();
        let width = this.props.width;

        let miiList = [];
        let size = 60;
        let start = 1410;

        for (let i=0; i<(19*5); i++) {
            miiList.push(<Link to={`${process.env.PUBLIC_URL}/players/${start+i}`}><Mii loading={false} src={shared.getMiiB64(start+i)} key={start+i} i={start+i} width={size} height={size} /></Link>);
        }

        return (
            <div className="App-description">
              <p>{appContent.description[0]}</p>
              <div style={{width:"80%", paddingLeft:"10%"}}><GameView yGrid={165} /></div>

              <h2>Faces of For Glory</h2>
              <p>On record, we currently have logged over 200 hours of play, 3795 2v2 matches, and 2720 1v1s. We've come across 2342 other players, with game data against 2032 of them. If you’ve played For Glory on the weekends this past year and are close enough to be matched against people in NorCal, we might have played you! You can explore the dataset and <Link className="button-link" to={process.env.PUBLIC_URL + "/players/"}>see the miis here</Link>. You can filter them by characters played, mii name, game mode, and more. As I built the program, I increased its functionality, so some of the earlier games don’t have complete data.</p>

              
              <div className="mii-list" style={{width:"60%", paddingLeft:"20%"}}>
                {miiList}
              </div>
              
              
              <h2>Popularity Tier Lists</h2>
              <p>{appContent.description[2]}</p>
              <div className="tiers">
                  <h4>Singles</h4>
                  <img src={singles} alt="singles tierlist"/>
                  <h4>Doubles</h4>
                  <img src={doubles} alt="doubles tierlist"/>
              </div>
            </div>
        );
    }
}

export default Home;
